import Vue from 'vue'
import { loadStripe } from '@stripe/stripe-js'
import configApp from '@/config'

let stripe = new Vue({
  data () {
    return {
      publicKey: configApp.stripePublicKey
    }
  },

  methods: {
    init (params) {
      loadStripe(this.publicKey, {
        stripeAccount: params.stripeAccount
      })
        .then(
          result =>
            result.redirectToCheckout({
              sessionId: params.sessionId
            }).then(
              result => console.log(result)
            ).catch(
              error => console.error(error)
            )
        )
        .catch(
          error => {
            console.error(error)
            this.$alerts.pushAlert('mEditionAcademyConfiguration', 'updateAcademia', 'error', 'a-alert-danger')
          }
        )
    }
  }
})

export default {
  install: (Vue) => {
    Vue.prototype.$stripe = stripe
  }
}
